/**
 * Utility برای حل مشکل scroll در صفحات
 */
import { useEffect } from 'react';

// Ensure scroll works after heavy processing
export const ensureScrollable = () => {
  // Force layout recalculation
  document.body.style.minHeight = '100vh';
  
  // Enable scroll
  document.body.style.overflowY = 'auto';
  document.documentElement.style.overflowY = 'auto';
  
  // Force reflow
  void document.body.offsetHeight;
  
  // Scroll to top smoothly
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 100);
};

// Fix mobile scroll issues
export const fixMobileScroll = () => {
  // Fix iOS scroll bounce
  document.body.style.webkitOverflowScrolling = 'touch';
  
  // Fix Android scroll issues
  if (/Android/i.test(navigator.userAgent)) {
    document.body.style.transform = 'translateZ(0)';
  }
  
  // Ensure minimum height
  const viewport = window.visualViewport;
  if (viewport) {
    const updateHeight = () => {
      document.body.style.minHeight = `${viewport.height}px`;
    };
    
    viewport.addEventListener('resize', updateHeight);
    updateHeight();
  }
};

// Hook for scroll restoration
export const useScrollRestoration = () => {
  useEffect(() => {
    ensureScrollable();
    fixMobileScroll();
    
    // Cleanup on unmount
    return () => {
      document.body.style.minHeight = '';
      document.body.style.overflowY = '';
      document.documentElement.style.overflowY = '';
      document.body.style.webkitOverflowScrolling = '';
      document.body.style.transform = '';
    };
  }, []);
};
